import { useLocation } from '@reach/router';
import { graphql } from 'gatsby';
import React, { useEffect } from 'react';
import './anchorLinks.scss';
import gsap from 'gsap';

interface Props {
  items: {
    text: string;
    title: string;
    color: string;
    hashtag: string;
    icon: {
      localFile: {
        publicURL: string;
      };
    };
  }[];
}

const AnchorLinks: React.FC<Props> = (props) => {
  const location = useLocation();

  useEffect(() => {
    const elementId = 'a-' + location.hash.replace('#', '');
    const element = document.getElementById(elementId);
    const layout = document.getElementsByClassName('layout-main');

    if (!!element && layout.length) {
      const offsetTop = (layout[0] as HTMLElement).offsetTop;
      gsap.to(window, {
        duration: 0.4,
        scrollTo: element.offsetTop - offsetTop,
      });
    }
  }, [location.hash]);

  return (
    <div className="anchor-links">
      <div className="anchor-links-wrapper">
        <div className="anchor-links__inner">
          <div className="anchor-links-row">
            {props.items.map((item, key) => {
              const link = '#' + item.title.toLowerCase().replace(' ', '-');
              return (
                <div key={key} className="anchor-links__item">
                  <div className="anchor-links__top" style={{ backgroundColor: `#${item.color}` }}>
                    <div className="anchor-links-top__inner">
                      <img className="anchor-links__top-icon" src={item.icon.localFile.publicURL} />

                      <h4 className="anchor-links__top-headline">{item.title}</h4>
                    </div>
                  </div>
                  <div className="anchor-links__bottom">
                    <p>{item.text}</p>
                    <a href={link} className="anchor-links__button link-text">
                      <span>MEHR ERFAHREN</span>
                    </a>
                  </div>
                  <a href={link} className="anchor-links__item-area" />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnchorLinks;

export const query = graphql`
  fragment AnchorLinksBlock on WpAcfAchorlinksBlock {
    AnchorLinks {
      items {
        text
        title
        color
        hashtag
        icon {
          ...OGImage
        }
      }
    }
  }
`;
